import FETCH from "../utils/fetch";
import ROUTES from "../config/routes";

// const RAG_STREAM_SEARCH_URL =
//   "https://54xwsmb6yza3zoiurmyxxjfage0pdiwl.lambda-url.us-east-1.on.aws"; // stage URL

const RAG_STREAM_SEARCH_URL = "https://2rfzndikigdvvfztrv2b2b5mxm0muovf.lambda-url.us-west-2.on.aws"; // live URL

const getAuthHeaders = () => {
  const token = localStorage.getItem("userLoginToken");
  const headers = {
    "Content-Type": "application/json",
    Accept: "text/event-stream, application/json, text/plain, */*",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

const buildQueryString = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return query.toString();
};

const ingestDocumentRAG = async (body) => {
  const res = await FETCH.post({
    url: `${ROUTES.RAG_DOCUMENT_INJESTION}`,
    body,
  });

  return res;
};

const searchDocumentsRAG = async (body) => {
  const res = await FETCH.post({
    url: `${ROUTES.RAG_DOCUMENT_SEARCH}`,
    body,
  });

  return res;
};

const listDocumentsRAG = async (params = {}) => {
  const { page = 1, limit = 20, module, ...filters } = params;
  const queryString = buildQueryString({
    page,
    limit,
    ...(module ? { module } : {}),
    ...filters,
  });

  return FETCH.get({
    url: `${ROUTES.LIST_RAG_DOCUMNETS}?${queryString}`,
  });
};

const getDocumentRAG = async (documentId) => {
  return FETCH.get({
    url: ROUTES.RAG_DOCUMENT_DETAIL,
    id: documentId,
  });
};

const deleteDocumentRAG = async (documentId) => {
  return FETCH.deletee({
    url: `${ROUTES.DELETE_RAG_DOCUMENT}/${documentId}`,
  });
};

const streamSearchDocumentsRAG = async (body, options) => {
  const fetchOptions = options || {};

  return fetch(RAG_STREAM_SEARCH_URL, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
    signal: fetchOptions.signal,
  });
};

const RAG_API = {
  ingestDocumentRAG,
  injestDocumentRAG: ingestDocumentRAG,
  searchDocumentsRAG,
  listDocumentsRAG,
  getDocumentRAG,
  deleteDocumentRAG,
  streamSearchDocumentsRAG,
};
export default RAG_API;
